export const linksPerDomainParamSelector = state => state.params.linksPerDomain;
export const pageParamSelector = state => state.params.page;
export const sourceParamSelector = state => state.params.source;
export const urlParamSelector = state => state.params.url;
